import { put, takeEvery } from "redux-saga/effects";
import { fetchGraphMethod } from "../../../../services/httpService";
import messagePopup from "../../../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
  academicSelectivity_LIST_START: "academicSelectivity_LIST_START",
  academicSelectivity_LIST_SUCCESS: "academicSelectivity_LIST_SUCCESS",
  academicSelectivity_LIST_FAILED: "academicSelectivity_LIST_FAILED",
};

// ============================================ Actions ========================================================
export const academicSelectivityListStart = (data) => ({
  type: actionType.academicSelectivity_LIST_START,
  payload: data,
});

export const academicSelectivityListSuccess = (data) => ({
  type: actionType.academicSelectivity_LIST_SUCCESS,
  payload: data,
});

export const academicSelectivityListFailed = (data) => ({
  type: actionType.academicSelectivity_LIST_FAILED,
  payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
  loading: false,
  data: null,
  error: null,
};

export default function academicSelectivityListReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case actionType.academicSelectivity_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case actionType.academicSelectivity_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case actionType.academicSelectivity_LIST_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return { ...state };
  }
}

// ===================================================== side effect =============================================

export function* academicSelectivityListSaga(action) {
  try {
    const response = yield fetchGraphMethod(
      action.payload.query,
      action.payload.variables,
      true
    );
    if (response && response.status === 200) {
      const allacademicSelectivity = response.data.data.allAcadamicselectivities?.Acadamicselectivities
        ? response.data.data.allAcadamicselectivities?.Acadamicselectivities
        : null;
      let finalData = [];
      yield put(academicSelectivityListSuccess(allacademicSelectivity));
    } else {
      messagePopup("", "COLLEGE List failed", "error");
      yield put(academicSelectivityListFailed("academicSelectivity List failed"));
    }
  } catch (error) {
    messagePopup("", "academicSelectivity List failed", "error");
    yield put(academicSelectivityListFailed("academicSelectivity List failed"));
  }
}

export function* watchacademicSelectivityListSaga() {
  yield takeEvery(actionType.academicSelectivity_LIST_START, academicSelectivityListSaga);
}
